// extracted by mini-css-extract-plugin
export default {"carousel":"learning-carousel_carousel__iGg+m","focusOnly":"learning-carousel_focusOnly__qeSHY"};